<template>
  <EDialog
    :dialog-title="dialogTitle"
    :center-dialog-visible="visible"
    :popup-width="'800px'"
    :show-btn="false"
    :show-close-btn="true"
    @resetPopupData="resetPopupData"
  >
    <div class="checkRole">
      <el-form label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="角色名称:" prop="roleName">
              <span>{{ formData?.roleName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所属平台:">
              <span>{{ formData?.systemName }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="角色描述:" prop="roleDesc">
              <span>{{ formData?.remark }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="权限清单:" prop="roleAuth">
              <div
                v-if="authTree.length > 0"
                style="overflow-y: auto; height: 300px"
              >
                <el-tree
                  :data="authTree"
                  :props="defaultProps"
                  :default-expand-all="true"
                ></el-tree>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </EDialog>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog';
import Api from '../../../api/authority/index';

export default {
  name: 'CheckRoleDialog',
  components: {
    EDialog,
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    roleData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialogTitle: '查看角色',
      formData: {},
      authTree: [],
      defaultProps: {
        children: 'childList',
        label: 'authName',
      },
    };
  },
  computed: {},
  created() {
    this.queryByRoleId();
    this.getRoleAuth();
  },
  methods: {
    resetPopupData() {
      this.$emit('close');
    },
    submitPopupData() {},
    queryByRoleId() {
      const params = {
        roleId: this.roleData.roleId,
      };
      Api.queryByRoleId(params).then((res) => {
        if (res.code === '200') {
          console.log(res.data);
          this.formData = res.data;
        }
      });
    },
    getRoleAuth() {
      const params = {
        roleId: this.roleData.roleId,
      };
      Api.checkAuth(params).then((res) => {
        if (res.code === '200') {
          console.log(res.data);
          this.authTree.push(res.data);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.checkRole {
  :deep(.el-form-item) {
    margin-bottom: 10px;
    white-space: nowrap;
  }
}
</style>
